var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-screen flex w-full bg-img" }, [
    _c(
      "div",
      {
        staticClass:
          "vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center"
      },
      [
        _c("vx-card", [
          _c(
            "div",
            {
              staticClass: "full-page-bg-color",
              attrs: { slot: "no-body" },
              slot: "no-body"
            },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "vx-col sm:w-full md:w-full lg:w-3/4 mx-auto self-center d-theme-dark-bg"
                  },
                  [
                    _c("validation-observer", {
                      ref: "a2faForm",
                      staticClass: "p-4",
                      attrs: { tag: "div" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var valid = ref.valid
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "vx-logo flex justify-items-center items-center mb-2 pt-1"
                                },
                                [
                                  _c("img", {
                                    staticClass: "mx-auto",
                                    staticStyle: { "max-height": "25px" },
                                    attrs: {
                                      src: require("@/assets/images/logo/logo.png"),
                                      alt: "logo"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "vx-card__title mb-2" },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "mb-2 mt-4 grid justify-items-center"
                                    },
                                    [_vm._v("Validação do seu Acesso")]
                                  ),
                                  _c("p", [
                                    _vm._v("Por favor, acesse o aplicativo "),
                                    _c("b", [_vm._v("Google Authenticator")]),
                                    _vm._v(" para validar o seu Acesso.")
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      "Alternativamente, você pode utilizar a chave "
                                    ),
                                    _c("b", [_vm._v(_vm._s(_vm.a2faCode))]),
                                    _vm._v(".")
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-items-center items-center grid mb-2 pt-1"
                                },
                                [
                                  _c("b-img", {
                                    staticStyle: { "max-width": "200px" },
                                    attrs: {
                                      src: _vm.qrCode2fa,
                                      alt: "QR Code 2FA"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("validation-provider", {
                                attrs: { name: "Código", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("vs-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass: "w-full",
                                            attrs: {
                                              "data-vv-validate-on": "blur",
                                              type: "text",
                                              "label-placeholder": "Código"
                                            },
                                            model: {
                                              value: _vm.code2fa,
                                              callback: function($$v) {
                                                _vm.code2fa = $$v
                                              },
                                              expression: "code2fa"
                                            }
                                          }),
                                          _c(
                                            "label",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-row gap-2 flex-wrap justify-center mt-1"
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "vs-button",
                                        {
                                          attrs: { disabled: !valid },
                                          on: { click: _vm.verify2fa }
                                        },
                                        [_vm._v("Validar Acesso")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "vs-button",
                                        {
                                          attrs: {
                                            type: "border",
                                            to: "/login"
                                          }
                                        },
                                        [_vm._v("Voltar para Login")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }